<template>
  <div class='dashboard-container'>
    <div class='dashboard-header'>
      <div class='header-upper'>
        <h2>COMPENDIUM</h2>
        <div class='profile-btn'>
          <i class='fas fa-user-circle'></i>
          <i class='fas fa-chevron-down'></i>
        </div>
      </div>
      <div class='header-lower'>
        <span>My Team</span>
      </div>
    </div>
    <div class="body">
      <h2>My Events:</h2>
      <div class='event-container'>
        <router-link v-for='event in events' :key='event.id' :to="'/event/'+event.id">
          <div class='event-card'>
            <h4>{{event.name}}</h4>
          </div>
        </router-link>
        <router-link to='/eventcreate'>
          <div class='event-card'>
            <h4>Create Event</h4>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import notificationList from "../notificationList";
export default {
  props: ["id"],
  data() {
    return {
      events: []
    };
  },
  methods: {
    getEvents: function() {
      return this.$store.dispatch("events/list", {});
    }
  },
  beforeMount: function() {
    this.getEvents().then(events => {
      this.events = this.$store.getters["events/events"];
    });
  },
  components: {
    notificationList
  }
};
</script>

<style scoped lang='scss'>
.event-container {
  display: flex;
}

.event-card {
  height: 140px;
  width: 180px;
  background: white;
  margin: 0px 12px;
  border-radius: 4px;
  padding: 12px;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.15);
  color: hsl(233.8, 31.7%, 24.1%);
  h4 {
    margin: 0px;
  }
}

.dashboard-container {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.dashboard-header {
  flex-shrink: 0;
  background: white;
  color: $primary;
  border-bottom: 1px solid $gray-4;
  border-top: 6px solid $secondary;

  .profile-btn {
    color: $punch;
    padding: 8px 16px;
    border-radius: 4px;
    box-shadow: 0 1px 5px hsla(0, 0%, 0%, 0.2);
    font-size: 2rem;
  }

  .header-upper {
    h2 {
      letter-spacing: 6px;
    }
    padding: 4px 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .header-lower {
    margin-top: 8px;
    margin-bottom: 24px;
    font-weight: 800;
    font-size: 2.2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    > span {
      margin: 0px 24px;
    }
  }
  .header-nav {
    margin-top: 48px;
    font-size: 1.2rem;
    font-weight: 800;
    display: flex;
    flex-direction: row;
    justify-content: center;
    > div {
      margin: 0px 30px;
      padding: 0px 24px;
    }
    > div:hover {
      color: $secondary;
      border-bottom: 6px solid $secondary;
    }
    .selected {
      color: $secondary;
      border-bottom: 6px solid $secondary;
    }
  }
}
.body {
  background: $gray-1;
  color: $primary;
  flex-grow: 1;
  padding: 20px 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/index.vue